angular.module('zc.projects')

.directive 'campaignConfirmStep', ($state, $translate, Project, InterestWidget, AccessStats, currencies) ->
  restrict: 'E'
  scope:
    campaign: '='
    allValid: '='
    basicForm: '='
    templateForm: '='
    incentiveForm: '='
    botbonnieForm: '='
    policyForm: '='
    scheduleForm: '='
    changeStatus: '&'
    changeInterestWidgetStatus: '&'
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_confirm_step.html'
  link: (scope, element, attrs) ->
    Project.get(scope.campaign.project_id).then (project) ->
      scope.project = project
      scope.currency = currencies[project.currency]
      scope.campaign_segments = project.campaign_segments
      scope.campaign_policy_sets = project.campaign_policy_sets
      scope.segment_access_stats =
        session_count: 0
        conversion_count: 0
        history_count: 0

      scope.campaign_policy_sets.unshift {id: null, name: $translate.instant('projectsCampaigns.directives.campaignConfirmStep.unspecified')}
      scope.campaign_segments.unshift {id: null, name: $translate.instant('projectsCampaigns.directives.campaignConfirmStep.unspecified')}

      InterestWidget.all(project.apikey)
      .then (interestWidgets) ->
        interestWidget = _.find(interestWidgets, (iw) -> (iw.campaign.id is scope.campaign.id))
        if interestWidget
          scope.campaign.iw_status = interestWidget.status

    scope.$watch 'campaign.start_at_obj.date', (startAt) ->
      scope.is_start_at_before_today = scope.campaign.start_at_obj.date < moment().startOf('day').valueOf()



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_confirm_step.coffee